import { render } from "./EducationBlog.vue?vue&type=template&id=94eacac2&scoped=true"
import script from "./EducationBlog.vue?vue&type=script&lang=js"
export * from "./EducationBlog.vue?vue&type=script&lang=js"

import "./EducationBlog.vue?vue&type=style&index=0&id=94eacac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94eacac2"]])

export default __exports__